import { Version } from '@repo/toolkit/types'
import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { Formula, FormulaSort } from '../../lib/types/models/formula/formula'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getFormulas(input: PaginationRequest<null, string, Version, FormulaSort> = {}) {
  if (!input.sort) input.sort = { title: 'asc' }
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.formulas.getAll.url, null), input))
    .get<PaginationResponse<Formula>>()
}
